import { FC, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { Form as FormAnt, Input, ModalProps, Typography, message } from "antd";
import { Modal } from '@hdi-seguros/web-components.modal';

import InsurancePolicyService from "../../../../../shared/services/insurancePolicy";
import { InsurancePolicy } from "../../../../../shared/interfaces";
import { Column, _renderColumns } from "../../utils/renderSections";

import { ColSize, RowSize, InputForm, Form } from "../../../../../shared/components";
import { ValidateForm } from "../../../../../shared/utils";


interface RevertEndorsementModalProps extends ModalProps {
    insurancePolicy?: InsurancePolicy
    onClose: () => void;
    onConfirm: () => void;
}

export const RevertEndorsementModal: FC<RevertEndorsementModalProps> = ({ open, title, onClose, insurancePolicy, onConfirm }) => {
    const [loading, setLoading] = useState(false);


    const onRevertEndorsement = async () => {
        setLoading(true);
        const {rama, nroPoliza, numeroEndosoParaRevertir} = insurancePolicy!;

        try {
            
            const response = await InsurancePolicyService.postRevertEndorsement( {rama, poliza:nroPoliza, suplemento: numeroEndosoParaRevertir} );

            if (response) {
                message.success('Endoso revertido con éxito');
                onConfirm();
                onClose();
            }
        } catch (error) {
            message.error(`Hubo un error intentando revertir el endoso: ${insurancePolicy?.nroPoliza}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title={title}
            centered
            open={open}
            width={650}
            onCancel={onClose}
            onOk={onRevertEndorsement}
            confirmText={'Revertir'}
            footer
            loadingConfirmButton={loading}
            className="suscribe-policy-modal-container"
        >
            <>
                <RowSize
                    rowProps={{ gutter: [0, 0], justify: 'end', align: 'middle' }}
                    className="row-pop-up-suscribe-policy"
                >
                    <ColSize size={100}>
                        <Typography.Text>
                            ¿Esta seguro que desea revertir el endoso de la póliza {insurancePolicy?.nroPoliza}?
                        </Typography.Text>
                    </ColSize>
                </RowSize>
            </>
        </Modal>
    )
}